module.exports = __webpack_public_path__ + "static/media/mobile.b7c18dcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/mobile.svg
// module id = 177
// module chunks = 0